export const EvaluationRecruitmentCriterion = {
    path: '/evaluation_recruitment_criterion',
    name: 'evaluation_recruitment_criterion',
    component: () => import('@/views/Evaluation/Measure/EvaluationRecruitmentMeasurePage.vue'),
    props: {
        type: 'EVALUATION_RECRUITMENT',
    },
    children: [
        {
            path: '/evaluation_recruitment_criterion/add',
            name: 'evaluation_recruitment_criterion.add',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_RECRUITMENT',
            }
        },
        {
            path: '/evaluation_recruitment_criterion/edit/:id',
            name: 'evaluation_recruitment_criterion.edit',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                updateAction: true,
                type: 'EVALUATION_RECRUITMENT',
            }
        },
        {
            path: '/evaluation_recruitment_criterion/delete/:id',
            name: 'evaluation_recruitment_criterion.delete',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_RECRUITMENT',
            }
        },
        {
            path: '/evaluation_recruitment_criterion/view/:id',
            name: 'evaluation_recruitment_criterion.view',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_RECRUITMENT',
            }
        },
    ]
}